import colors from "../base/colors";

const index = {
  styleOverrides: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    root: {
      backgroundColor: colors.white.main,
    },
  },
};
export default index;
